import React from "react";
import Moment from 'react-moment';
import muiThemeable from 'material-ui/styles/muiThemeable';
import RaisedButton from "material-ui/RaisedButton";
import { ValidatorForm } from "react-form-validator-core";
import { TextValidator, SelectValidator } from "react-material-ui-form-validator";
import MenuItem from "material-ui/MenuItem";
import Snackbar from "material-ui/Snackbar";
import CircularProgress from "material-ui/CircularProgress";
import LinearProgress from 'material-ui/LinearProgress';
import ActionSettings from "material-ui/svg-icons/action/settings";
import ActionDeleteForever from "material-ui/svg-icons/action/delete-forever";
import History from 'material-ui/svg-icons/action/history';
import AvPauseCircleOutline from "material-ui/svg-icons/av/pause-circle-outline";
import AvPlayCircleOutline from "material-ui/svg-icons/av/play-circle-outline";
import AvPlayArrow from "material-ui/svg-icons/av/play-arrow";
import Toggle from 'material-ui/Toggle';
import Drawer from 'material-ui/Drawer';
import IconMenu from 'material-ui/IconMenu';
import IconButton from 'material-ui/IconButton';
import NavigationMoreVert from 'material-ui/svg-icons/navigation/more-vert';
import { Toolbar, ToolbarGroup } from 'material-ui/Toolbar';
import NavigationClose from 'material-ui/svg-icons/navigation/close';
import { grey500, deepOrange700 } from 'material-ui/styles/colors';

import { PostJob, PatchJob, PauseJob, ResumeJob, RemoveJob, RunJob } from "../../../http/SchedulerService";
import { isFormValid, isCronDefined, AddIsJsonValidation, AddIsUrlValidation } from '../../../helpers/JobHelpers';
import SettingsDialog from './SettingsDialog';
import ConfirmDeletionDialog from './ConfirmDeletionDialog';
import { FlatButton } from "material-ui";
import HistoryModal from "./HistoryModal";

class JobViewDrawer extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            drawerWidth: 800,
            requesting: false,
            job: null,
            settingsDialogOpen: false,
            confirmeDeletionDialogOpen: false,
            paramsToJson: false,
            snackbarOpen: false,
            snackbarMsg: "",
            showHeaders: false,
            historyDialogOpen: false
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleSelectChange = this.handleSelectChange.bind(this);
        this.handleToggleParamsToJson = this.handleToggleParamsToJson.bind(this);
        this.handleToggleShowHeaders = this.handleToggleShowHeaders.bind(this);
        this.onCloseDrawer = this.onCloseDrawer.bind(this);
        this.onDrawerRequestChange = this.onDrawerRequestChange.bind(this);
    }

    updateDimensions() {
        this.setState({ drawerWidth: window.innerWidth > 800 ? 800 : '100%' });
    }

    componentDidMount() {
        this.updateDimensions();
        window.addEventListener("resize", this.updateDimensions.bind(this));
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.updateDimensions.bind(this));
    }

    componentWillMount() {
        AddIsJsonValidation(ValidatorForm);
        AddIsUrlValidation(ValidatorForm);
    }

    componentDidUpdate() {
        const { job } = this.props;

        if (job && job.id && (!this.state.job || (job.id !== this.state.job.id))) {
            this.setJobState(job);
            this.setState({ newJob: false, showHeaders: !Boolean(job.kwargs.headers) });
        }
        else if (job === 'new' && (!this.state.job || !this.state.newJob)) {
            this.setState({
                job: {
                    id: "",
                    func: "",
                    name: "",
                    trigger: "cron",
                    minute: "",
                    hour: "",
                    day: "",
                    month: "",
                    day_of_week: "",
                    "args.0": "",
                    "args.1": "",
                    "kwargs.headers": ""
                },
                newJob: true
            });
            return;
        }
        else if (job === null && this.state.job !== null) {
            this.setState({job: null});
        }
    }

    handleToggleParamsToJson(event) {
        this.setState({ paramsToJson: event.target.checked });
        this.setJobState(this.state.job);
        this.props.handleDirtyForm(true);
    }

    handleToggleShowHeaders(event) {
        this.setState({ showHeaders: event.target.checked });
    }

    handleChange(event) {
        const { job } = this.state;
        job[event.target.name] = event.target.value;
        this.setState({ job });
        this.props.handleDirtyForm(true);
    }

    handleSelectChange = (name) => (event, key, payload) => {
        const { job } = this.state;
        job[name] = payload;
        this.setState({ job });
        this.props.handleDirtyForm(true);
    };

    showSnackbarMessage = message => {
        this.props.showSnackbarMessage(message);
    };

    onCloseDrawer = () => {
        if (!this.state.requesting) {
            this.props.onCloseDrawer();
        }
    }

    handleSubmit() {
        this.setState({ requesting: true });

        let job = this.fixJobObject(this.state.job, true);

        if (!this.state.newJob) {
            PatchJob(job).then(result => {
                this.showSnackbarMessage(`Tarefa atualizada!`);
                this.setState({ requesting: false });
                this.setJobState(result.data);
                this.props.onJobSubmit(result.data);
            })
                .catch(error => {
                    this.showSnackbarMessage(String(error));
                    this.setState({ requesting: false });
                });
        }
        else {
            PostJob(job)
                .then(result => {
                    this.showSnackbarMessage(`Tarefa criada!`);
                    this.setState({ newJob: false, requesting: false });
                    this.props.onJobSubmit(result.data);
                })
                .catch(error => {
                    this.showSnackbarMessage(String(error));
                    this.setState({ requesting: false });
                });
        }
    }

    setJobState = (_job) => {
        let job = { ..._job };
        job.minute = job.minute || "";
        job.hour = job.hour || "";
        job.day = job.day || "";
        job.month = job.month || "";
        job.day_of_week = job.day_of_week || "";

        try {
            let args1 = job.args[1];

            if (this.state.paramsToJson || typeof args1 === 'object') {
                args1 = JSON.stringify(job.args[1], null, 2);
            }

            job["args.0"] = job.args[0];
            job["args.1"] = args1;
            job["kwargs.headers"] = JSON.stringify(job.kwargs.headers, null, 2);
        } catch (e) { };

        this.setState({ job: job });
    }

    fixJobObject = (_job, removeBlank) => {
        let job = { ..._job };

        job.id = job.id && this.state.newJob ? job.id.trim() : job.id;
        job.name = job.name ? job.name.trim() : job.name;

        job.args = [job["args.0"] ? job["args.0"].trim() : job["args.0"]];

        if (job.func === "jobs:http_post") {
            try {
                const args1 = this.state.paramsToJson ? JSON.parse(job["args.1"]) : job["args.1"];
                job.args.push(args1);
            } catch (e) { }
        }

        if (job["kwargs.headers"]) {
            try {
                job.kwargs = {
                    headers: JSON.parse(job["kwargs.headers"])
                }
            } catch (e) { }
        }

        delete job["args.0"];
        delete job["args.1"];
        delete job["kwargs.headers"];
        delete job["next_run_time"];

        if (removeBlank) {
            Object.keys(job).filter(a => job[a] === '').map(a => delete job[a]);
        }    

        return job;
    };

    handleSettingsDialogOpen = () => {
        this.setState({ settingsDialogOpen: true });
        setTimeout(() => window.dispatchEvent(new Event('resize')));
    };

    handleRemove = () => this.setState({ confirmeDeletionDialogOpen: true });

    handleSettingsDialogClose = (job) => {
        this.setState({ settingsDialogOpen: false });
    };

    confirmeDeletionDialogClose = () => {
        this.setState({ confirmeDeletionDialogOpen: false });
    };

    confirmeDeletionDialogConfirm = () => {
        RemoveJob(this.state.job).then(result => {
            this.confirmeDeletionDialogClose();
            this.showSnackbarMessage(`Tarefa removida!`);
            this.props.onJobSubmit(this.state.job, { removed: true });
        })
            .catch(error => this.showSnackbarMessage(String(error)));
    };

    handleSettingsDialogSubmit = (job) => {
        this.setJobState(job);

        this.setState({ settingsDialogOpen: false });
        this.props.handleDirtyForm(true);
    };

    handlePause = () => {
        this.setState({ requesting: true });

        PauseJob(this.state.job).then(result => {
            this.showSnackbarMessage(`Tarefa desativada!`);
            this.setJobState(result.data);
            this.setState({ requesting: false });
            this.props.onJobSubmit(result.data);
        })
            .catch(error => {
                this.showSnackbarMessage(String(error));
                this.setState({ requesting: false });
            });
    };

    handleResume = () => {
        this.setState({ requesting: true });

        ResumeJob(this.state.job).then(result => {
            this.showSnackbarMessage(`Tarefa ativada!`);
            this.setJobState(result.data);
            this.setState({ requesting: false });
            this.props.onJobSubmit(result.data);
        })
            .catch(error => {
                this.showSnackbarMessage(String(error));
                this.setState({ requesting: false });
            });
    };

    handleRun = () => {
        this.setState({ requesting: true });

        RunJob(this.state.job).then(result => {
            this.showSnackbarMessage(`Tarefa executada!`);
            this.setJobState(result.data);
            this.setState({ requesting: false });
        })
            .catch(error => {
                this.showSnackbarMessage(String(error));
                this.setState({ requesting: false });
            });
    };

    onDrawerRequestChange = function (open, reason) {
        if (reason === 'escape' && !this.state.settingsDialogOpen && !this.state.requesting) {
            this.onCloseDrawer();
        }
    }

    handleOpenViewHistory = () => {
        this.setState({ historyDialogOpen: true });
    };
    
    handleCloseViewHistory = () => {
        this.setState({ historyDialogOpen: false });
    };

    render() {
        const { newJob, job, requesting, showHeaders, drawerWidth, paramsToJson } = this.state;
        let fixJobObject = this.fixJobObject(job);
        const isJobValid = isFormValid(job, paramsToJson);
        const cronDefined = isCronDefined(job);

        const funcItems = [
            <MenuItem key="http_get" value="jobs:http_get" primaryText="http GET" />,
            <MenuItem key="http_post" value="jobs:http_post" primaryText="http POST" />
        ];

        const displayOverlay = requesting ? 'block' : 'none';

        return (
            <Drawer
                width={drawerWidth}
                openSecondary={true}
                open={this.props.drawerOpen}
                disableSwipeToOpen={true}
                containerStyle={{ top: 64 }}
                docked={false}
                overlayStyle={{ display: displayOverlay, backgroundColor: 'rgba(0, 0, 0, 0.05)' }}
                onRequestChange={this.onDrawerRequestChange}
            >

                <Toolbar style={{ height: 78, padding: '0 4px 0 24px' }}>
                    <ToolbarGroup firstChild={true}>
                        <div style={{ paddingLeft: 12, display: 'flex' }}>
                            <IconButton onClick={this.onCloseDrawer}>
                                <NavigationClose />
                            </IconButton>
                            <div style={{ alignSelf: 'center' }}>{(job && job.name) ? job.name : <span>NOVA TAREFA</span>}</div>
                        </div>
                    </ToolbarGroup>
                    <ToolbarGroup>

                        

                        <FlatButton
                            label="Executar"
                            icon={<AvPlayArrow />}
                            labelPosition="after"
                            onClick={this.handleRun}
                            disabled={newJob || requesting}
                        />

                        {!newJob &&
                            <IconMenu
                                iconButtonElement={
                                    <IconButton touch={true}>
                                        <NavigationMoreVert />
                                    </IconButton>
                                }>

                                <MenuItem
                                    primaryText="Histórico"
                                    leftIcon={<History />}
                                    disabled={newJob || !isJobValid || requesting}
                                    onClick={this.handleOpenViewHistory} />
                        
                                {!newJob && job && Boolean(this.state.job.next_run_time) &&
                                    <MenuItem
                                        primaryText="Desativar"
                                        leftIcon={<AvPauseCircleOutline />}
                                        disabled={!isJobValid || newJob || requesting}
                                        onClick={this.handlePause} />
                                }

                                {!newJob && job && !Boolean(this.state.job.next_run_time) &&
                                    <MenuItem
                                        primaryText="Ativar"
                                        leftIcon={<AvPlayCircleOutline />}
                                        disabled={!isJobValid || newJob || requesting}
                                        onClick={this.handleResume} />
                                }

                                <MenuItem
                                    primaryText="Remover"
                                    leftIcon={<ActionDeleteForever />}
                                    disabled={newJob || !isJobValid || requesting}
                                    onClick={this.handleRemove} />

                            </IconMenu>
                        }
                    </ToolbarGroup>
                </Toolbar>

                <div style={{ height: 'calc(100% - 142px)' }}>
                    <SettingsDialog
                        job={fixJobObject}
                        paramsToJson={paramsToJson}
                        open={this.state.settingsDialogOpen}
                        handleSubmit={this.handleSettingsDialogSubmit}
                        handleSettingsDialogClose={this.handleSettingsDialogClose} />

                    <ConfirmDeletionDialog
                        open={this.state.confirmeDeletionDialogOpen}
                        handleConfirm={this.confirmeDeletionDialogConfirm}
                        handleClose={this.confirmeDeletionDialogClose} />
                    
                    <HistoryModal 
                        open={this.state.historyDialogOpen}
                        job={fixJobObject}
                        handleClose={this.handleCloseViewHistory}
                    />

                    {job && (
                        <div style={{ height: '100%' }}>
                            <div style={{ height: 4 }}>{requesting && <LinearProgress mode="indeterminate" />}</div>

                            <div style={{ padding: "0 20px", height: 'calc(100% - 4px)' }}>

                                <ValidatorForm onSubmit={this.handleSubmit} style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                                    <div style={{ display: "flex" }}>

                                        <TextValidator
                                            name="id"
                                            value={job.id}
                                            validators={["required"]}
                                            errorMessages={["Informação obrigatória"]}
                                            floatingLabelText="Identificador"
                                            onChange={this.handleChange}
                                            autoComplete="off"
                                            readOnly={!newJob || requesting}
                                            style={{ flexGrow: 1 }}
                                        />

                                        <SelectValidator
                                            name="func"
                                            value={job.func}
                                            validators={["required"]}
                                            errorMessages={["Informação obrigatória"]}
                                            floatingLabelText="Tarefa"
                                            onChange={this.handleSelectChange("func")}
                                            disabled={requesting}
                                            style={{ flexGrow: 1 }}
                                        >
                                            {funcItems}
                                        </SelectValidator>
                                    </div>

                                    <TextValidator
                                        name="name"
                                        value={job.name}
                                        validators={["required"]}
                                        errorMessages={["Informação obrigatória"]}
                                        floatingLabelText="Nome da tarefa"
                                        onChange={this.handleChange}
                                        autoComplete="off"
                                        readOnly={requesting}
                                        fullWidth
                                    />

                                    <TextValidator
                                        name="args.0"
                                        value={job["args.0"]}
                                        validators={["required", "isUrl"]}
                                        errorMessages={["Informação obrigatória", "Deve conter uma URL válida"]}
                                        floatingLabelText="Recurso /URL"
                                        onChange={this.handleChange}
                                        autoComplete="off"
                                        readOnly={requesting}
                                        fullWidth
                                    />

                                    <TextValidator
                                        name="observation"
                                        value={job["observation"]}
                                        floatingLabelText="Observação"
                                        onChange={this.handleChange}
                                        autoComplete="off"
                                        readOnly={requesting}
                                        fullWidth multiLine rows={2} rowsMax={8}
                                    />

                                    {job.func === 'jobs:http_post' && !paramsToJson &&
                                        <TextValidator
                                            name="args.1"
                                            value={job["args.1"]}
                                            floatingLabelText="Corpo da requisição"
                                            onChange={this.handleChange}
                                            readOnly={requesting}
                                            autoComplete="off"
                                            fullWidth multiLine rows={2} rowsMax={8}
                                        />
                                    }

                                    {job.func === 'jobs:http_post' && paramsToJson &&
                                        <TextValidator
                                            name="args.1"
                                            value={job["args.1"]}
                                            validators={["isJson"]}
                                            errorMessages={["Deve conter formato JSON"]}
                                            floatingLabelText="Corpo da requisição"
                                            onChange={this.handleChange}
                                            readOnly={requesting}
                                            autoComplete="off"
                                            fullWidth multiLine rows={2} rowsMax={8}
                                        />
                                    }

                                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                                        {!newJob && job["kwargs.headers"] &&
                                            <div style={{ marginTop: 32 }}>
                                                <Toggle
                                                    label="Exibir Cabeçalho"
                                                    toggled={showHeaders}
                                                    disabled={requesting}
                                                    onToggle={this.handleToggleShowHeaders}
                                                />
                                            </div>
                                        }

                                        <div style={{ flexGrow: 1 }}></div>

                                        {job.func === 'jobs:http_post' &&
                                            <div style={{ fontSize: 12, marginTop: -8 }}>
                                                <Toggle
                                                    label="Converter para JSON"
                                                    toggled={paramsToJson}
                                                    disabled={requesting}
                                                    onToggle={this.handleToggleParamsToJson} />
                                            </div>
                                        }
                                    </div>

                                    {(newJob || !job["kwargs.headers"] || showHeaders) &&
                                        <TextValidator
                                            name="kwargs.headers"
                                            value={job["kwargs.headers"]}
                                            validators={["isJson"]}
                                            errorMessages={["Deve conter formato JSON"]}
                                            floatingLabelText="Cabeçalho da requisição"
                                            onChange={this.handleChange}
                                            autoComplete="off"
                                            readOnly={requesting}
                                            fullWidth multiLine rows={2} rowsMax={8}
                                        />
                                    }

                                    <div style={{ display: "flex", marginTop: 12 }}>
                                        <TextValidator
                                            name="minute"
                                            value={job.minute}
                                            floatingLabelText="Min (0-59)"
                                            onChange={this.handleChange}
                                            readOnly={requesting}
                                            autoComplete="off"
                                            style={{ flexGrow: 1 }}
                                        />

                                        <TextValidator
                                            name="hour"
                                            value={job.hour}
                                            floatingLabelText="Hor (0-23)"
                                            autoComplete="off"
                                            onChange={this.handleChange}
                                            readOnly={requesting}
                                            style={{ flexGrow: 1 }}
                                        />
                                        <TextValidator
                                            name="day"
                                            value={job.day}
                                            floatingLabelText="Dia (0-31)"
                                            onChange={this.handleChange}
                                            readOnly={requesting}
                                            autoComplete="off"
                                            style={{ flexGrow: 1 }}
                                        />
                                        <TextValidator
                                            name="month"
                                            value={job.month}
                                            floatingLabelText="Mês (1-12)"
                                            onChange={this.handleChange}
                                            readOnly={requesting}
                                            autoComplete="off"
                                            style={{ flexGrow: 1 }}
                                        />

                                        <TextValidator
                                            name="day_of_week"
                                            value={job.day_of_week}
                                            hintText="first: monday"
                                            floatingLabelText="Sem (0-6)"
                                            tooltip="coisa"
                                            onChange={this.handleChange}
                                            readOnly={requesting}
                                            autoComplete="off"
                                            style={{ flexGrow: 1 }}
                                        />

                                    </div>

                                    <div style={{ color: this.props.muiTheme.palette.primary1Color, fontSize: 12, display: "flex" }}>
                                        <div style={{ flexGrow: 1 }}>
                                            {!cronDefined && <div>* Defina uma programação para a tarefa</div>}
                                        </div>
                                    </div>

                                    <div style={{ display: "flex", marginTop: 'auto', marginBottom: 12 }}>
                                        {job.last_run_time &&
                                            <div style={{ padding: "0 10px 0 0", borderRight: "1px solid lightgray" }}>
                                                    <div>
                                                        <div style={{ color: grey500 }}>
                                                            ultima execução&nbsp;
                                                            <Moment interval={30000} fromNow style={{ fontWeight: 'bold' }}>{job.last_run_time}</Moment>
                                                        </div>
                                                        <div style={{ fontWeight: 'bold', color: deepOrange700, alignSelf: 'center' }}>
                                                            <Moment format="llll">{job.last_run_time}</Moment>
                                                        </div>
                                                    </div>
                                            </div>
                                            }
                                        {job.next_run_time &&
                                            <div style={{ padding: job.last_run_time ? "0 10px" : "0"}}>
                                                <div>
                                                    <div style={{ color: grey500 }}>
                                                        próxima execução&nbsp;
                                                        <Moment interval={30000} fromNow style={{ fontWeight: 'bold' }}>{job.next_run_time}</Moment>
                                                    </div>
                                                    <div style={{ fontWeight: 'bold', color: deepOrange700, alignSelf: 'center' }}>
                                                        <Moment format="llll">{job.next_run_time}</Moment>
                                                    </div>
                                                </div>
                                            </div>
                                        }


                                        <div style={{ flexGrow: 1 }}></div>

                                        <div>
                                            <FlatButton
                                                label="JSON"
                                                icon={<ActionSettings />}
                                                labelPosition="after"
                                                onClick={this.handleSettingsDialogOpen}
                                                disabled={requesting}
                                                style={{ marginRight: 12 }}
                                            />
                                            <RaisedButton
                                                label={newJob ? "Criar" : "Atualizar"}
                                                secondary={true}
                                                disabled={!isJobValid || requesting || !this.props.dirtyForm}
                                                type="submit"
                                                onClick={this.handleSubmit}
                                            />
                                        </div>
                                    </div>
                                </ValidatorForm>
                            </div>
                        </div>
                    )}

                    {!job && (<div style={{ textAlign: "center", paddingTop: 20 }}><CircularProgress /></div>)}

                    <Snackbar
                        open={this.state.snackbarOpen}
                        message={this.state.snackbarMsg}
                        autoHideDuration={3000}
                        onRequestClose={this.props.handleSnackbarClose}
                    />
                </div>
            </Drawer>
        );
    }
}

export default muiThemeable()(JobViewDrawer)


// WEBPACK FOOTER //
// ./src/components/view/scheduler/job/JobViewDrawer.js